import { useEffect, useState } from 'react'

import config from '../config'

declare global {
    interface Window {
        waffle:
            | {
                  flag_is_active: (flag: string) => boolean
                  switch_is_active: (flag: string) => boolean
              }
            | undefined
    }
}

const useFeatureFlag = (flag: string) => {
    /* Kinda hacky for making the useMemo works correctly,
    otherwise it never updates */
    const flagValue: boolean | undefined =
        window?.waffle?.flag_is_active(flag) ||
        window?.waffle?.switch_is_active(flag)

    const [featureFlag, updateFeatureFlag] = useState<boolean | undefined>(
        flagValue,
    )

    const checkFeatureFlag = () => {
        try {
            updateFeatureFlag(
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore

                window?.waffle?.flag_is_active(flag) ||
                    window?.waffle?.switch_is_active(flag),
            )
            // eslint-disable-next-line no-empty
        } catch (ignore) {}
    }

    useEffect(() => {
        checkFeatureFlag()
    }, [flagValue]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        let script = document.getElementById('wafflejs') as HTMLScriptElement

        async function asynchronousFlagCheck() {
            checkFeatureFlag()
        }

        if (script === null) {
            script = document.createElement('script')
            script.src = `${config.API_BASE_URL}/feature_flags/wafflejs`
            script.async = true
            script.id = 'wafflejs'
            document.body.appendChild(script)

            script.addEventListener('load', () => {
                checkFeatureFlag()
            })
        } else {
            asynchronousFlagCheck()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return featureFlag
}

export default useFeatureFlag
